import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './pedidoOcorrenciaForm';

import { setModoTela, initForm, salvar, excluir, getLista } from './pedidoOcorrenciaActions';
import DateFormat from '../common/dateFormat/DateFormat';

class PedidoOcorrencia extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista(this.props.idPedido);
    }

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({
										datahora_ocorrencia: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual()),
										id_pedido: this.props.idPedido,
										pedido_item: (this.props.pedidoItens || []).map(item => ({
											id: item.id,
											nome_cliente: item.nome_cliente,
											nome_endereco: item.nome_endereco,
											datahora_previsao_anterior: item.datahora_previsao_entrega,
											datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_entrega),
											previsao_alterada: false
										}))
									});
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Data/Hora</Th>
								<Th alignCenter>Descrição</Th>
								<Th alignCenter>Previsões Alteradas</Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).filter(item => {
								if (this.state.pesquisar
									&& !(`${item.nome} ${item.nome_unidade || ''} ${item.nome_produto || ''}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}
								return true;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_ocorrencia)}</Td>
									<Td alignCenter>{item.descricao}</Td>
									<Td alignCenter>
										{(item.pedido_item || []).filter(previsao => previsao.previsao_alterada).map(previsao => (
											<p key={previsao.id}>{previsao.nome_endereco} = de {DateFormat.formatarDataHoraSqlParaTela(previsao.datahora_previsao_anterior)} para {DateFormat.formatarDataHoraSqlParaTela(previsao.datahora_previsao_entrega)}</p>
										))}
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.pedidoOcorrencia,
	modoTela: state.pedidoOcorrencia.modoTela,
	lista: state.pedidoOcorrencia.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, excluir, getLista }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PedidoOcorrencia);
